import { useState, useEffect } from "react";
import { FloatingLabel, Container, FormControl, Card, Row, Col } from "react-bootstrap";
import ApiService from "../../../services/api";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import moment from "moment";

function ActivityList() {
  const [searchTerm, setSearchTerm] = useState("");
  const [activitiy, setActivitys] = useState([]);
  const [activitiyFiltred, setActivitysFiltred] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error] = useState(null);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const fetchGetActivity = async () => {
    const ActivityList = await ApiService.getActivity();
    const sortedActivity = ActivityList.sort((a, b) => b.id - a.id);
    setActivitysFiltred(sortedActivity);
    setActivitys(sortedActivity);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchGetActivity();
  }, []);

  useEffect(() => {
    const filtered = activitiy.filter(
      (item) =>
        (item.description &&
          item.description.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.user_data.username &&
          item.user_data.username
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (moment(item.date).format("DD-MM-YYYY HH:mm") &&
          moment(item.date).format("DD-MM-YYYY HH:mm").includes(searchTerm))
    );
    setActivitysFiltred(filtered);
  }, [searchTerm, activitiy]);

  const paginationOptions = {
    rowsPerPageText: "Elementi per pagina",
    rangeSeparatorText: "di",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Tutti",
  };

  const columns = [
    {
      name: "Data",
      selector: (row) => moment(row.date).format("DD-MM-YYYY HH:mm"),
      sortable: true,
      center: "true",
      width: "33%",
    },
    {
      name: "Utente",
      selector: (row) => row.user_data.username,
      sortable: true,
      center: "true",
      width: "33%",
    },
    {
      name: "Attivita",
      selector: (row) => row.description,
      sortable: true,
      center: "true",
      width: "33%",
    },
  ];

  if (isLoading) return;
  if (error) return;
  
  return <>
     <Container fluid className="p-0 m-0 text_data_admin px-2">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb pb-5 ps-5">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Attività
          </li>
        </ol>
      </nav>
    </Container>
    <Row>
        <Col lg="12" className="mb-5 pb-5">
            <div className="admin-card">
                <div className="admin-card-header">
                    <div className="admin-card-icon black-gradient">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-hourglass-split" viewBox="0 0 16 16">
                            <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                        </svg>
                    </div>
                    <p><small>Attività</small></p>
                </div>

                <div className="box_body_teams ps-3 py-4 text_size_data">
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Cerca una attività"
                    className="mb-0 w-100"
                  >
                    <FormControl
                      type="text"
                      placeholder=" Cerca pagina"
                      className="mr-sm-2"
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </FloatingLabel>
                </div>
                
                <DataTable
                  columns={columns}
                  data={activitiyFiltred}
                  pagination
                  paginationComponentOptions={paginationOptions}
                  paginationPerPage={30}
                />
            </div>
        </Col>
    </Row>   
  </>
}

export default ActivityList;
